import { type IApiError } from '@webapp/services/api'
import { parseAPIError } from '@webapp/utils/errors'

export const SCA_TOKEN_INSUFFICIENT = 'sca_token_insufficient'

interface ScaErrorBody {
  code?: unknown
  data?: unknown
  errors_with_codes?: { code?: unknown }[]
}

const isScaTokenInsufficientCode = (code: unknown) =>
  typeof code === 'string' && code.toLowerCase() === SCA_TOKEN_INSUFFICIENT

const bodyHasScaTokenInsufficientCode = (body: unknown): boolean => {
  if (!body || typeof body !== 'object') return false

  const { code, data, errors_with_codes } = body as ScaErrorBody

  return (
    isScaTokenInsufficientCode(code) ||
    (errors_with_codes ?? []).some((error) =>
      isScaTokenInsufficientCode(error?.code)
    ) ||
    isScaTokenInsufficientCode(
      parseAPIError(body as IApiError['data'], undefined, {}).code
    ) ||
    bodyHasScaTokenInsufficientCode(data)
  )
}

export const isScaTokenInsufficientError = (error: unknown): boolean => {
  if (!error || typeof error !== 'object') return false

  const { code, data, response } = error as ScaErrorBody & {
    response?: unknown
  }

  return (
    isScaTokenInsufficientCode(code) ||
    bodyHasScaTokenInsufficientCode(data) ||
    bodyHasScaTokenInsufficientCode(response)
  )
}
